/*
 * Public API Surface of chat-view
 */

export * from './lib/chat-view.service';
export * from './lib/chat-view.component';
export * from './lib/chat-view.module';

export * from './lib/components/message-data/message-data';
